import { render, staticRenderFns } from "./head-provider.vue?vue&type=template&id=c4f2886a"
import script from "./head-provider.vue?vue&type=script&lang=js"
export * from "./head-provider.vue?vue&type=script&lang=js"
import style0 from "./head-provider.vue?vue&type=style&index=0&id=c4f2886a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports